<template>
  <component
    :is="componentName"
    v-b-tooltip.hover
    class="font-weight-bold  item-details-link position-relative link-primary stretched-link"
    :title="translateObject"
    @focus="translate(position)"
  >
    <b-icon
      v-if="isVisited"
      :title="translations[11817]"
      icon="eye-fill"
      class="mr-2"
    ></b-icon>

    {{ position }}
  </component>
</template>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import GoogleTranslate from '@/mixins/GoogleTranslate';
import { AppModule } from '@/store/modules/app';

@Component
export default class JobDetailsLink extends mixins(GoogleTranslate) {
  @Prop({ type: Boolean, default: false }) readonly isVisited!: boolean;

  @Prop({ type: String, required: true }) readonly position!: string;

  get translations() {
    return AppModule.translation;
  }

  get componentName() {
    return this.$attrs.href ? 'a' : 'span';
  }
}
</script>

<style lang="scss" scoped>
.item-details-link {
  overflow-wrap: anywhere;
  font-size: 20px;
  color: var(--clr-h-theme-tag);
}
</style>
